

































































































































































































































import { computed, defineComponent, PropType } from '@vue/composition-api';
import navLink from '../header/navigation/nav-link.vue';
import subList from '../header/navigation/sub-list.vue';
import { useLog } from '@/common/log';
import { useIsLogin } from './hooks/useIsLogin';
import { RouteName } from '@/router';
import { NAVQUICK_LIST, NAVQUICK_MEDIUM_LIST } from './config';
import ConfigModel from '@/models/config';
import { useApolloModel } from 'vue-apollo-model';
import ABTestModel from '@/models/abtest';
import type { TextItemUI, SubListUI } from 'typings/ui';

export default defineComponent({
    components: {
        navLink,
        subList,
    },
    props: {
        isDark: Boolean,
        canSendShowLog: {
            type: Boolean,
            default: false,
        },
        navUiData: {
            type: Object as PropType<TextItemUI>,
        },
        subListUiData: {
            type: Object as PropType<SubListUI>,
        },
    },
    setup(props, ctx) {
        const log = useLog();
        const configModel = useApolloModel(ConfigModel);
        const abTestModel = useApolloModel(ABTestModel);
        const { isLogin, login } = useIsLogin();
        const navItemUIData = computed(() => {
            if (props.navUiData) {
                return {
                    color: props.navUiData?.defaultState.fontColor,
                    fontWeight: props.navUiData?.defaultState.fontWeight,
                };
            }
            return {};
        });
        const hoverUIData = computed(() => {
            if (props.navUiData) {
                return {
                    color: props.navUiData?.hoverState.fontColor,
                    fontWeight: props.navUiData?.hoverState.fontWeight,
                };
            }
            return {};
        });
        const subListBackground = computed(() => {
            if (props.subListUiData) {
                return {
                    background: props.subListUiData?.background,
                };
            }
        });
        const subListArrow = computed(() => {
            if (props.subListUiData && props.subListUiData.arrowIcon) {
                return {
                    backgroundImage: `url(${props.subListUiData.arrowIcon})`,
                };
            }
        });
        const subHoverUI = computed(() => {
            if (props.subListUiData && props.subListUiData.textState) {
                return {
                    color: props.subListUiData.textState.hoverState.fontColor,
                    fontWeight: props.subListUiData.textState.hoverState.fontWeight,
                };
            }
        });
        const subDefaultUI = computed(() => {
            if (props.subListUiData && props.subListUiData.textState) {
                return {
                    color: props.subListUiData.textState.defaultState.fontColor,
                    fontWeight: props.subListUiData.textState.defaultState.fontWeight,
                };
            }
        });
        function handleLink(item: any) {
            return item.id !== 'follow' || isLogin.value;
        }
        const name = ctx.root.$route.name;
        function isHigh(item: {routeName: string}) {
            return item.routeName === name;
        }
        const isHome = name === RouteName.Home;

        function isNewTag(item: { routeName: string}) {
            return item.routeName !== ctx.root.$route.name;
        }
        function handleMoveEnter(isActived: boolean, e: Event) {
            if (isActived) {
                return;
            }
            const target = e.target as HTMLElement;
            target.style.color = hoverUIData.value.color || '';
        }
        function handleMoveLeave(isActived: boolean, e: Event) {
            if (isActived) {
                return;
            }
            const target = e.target as HTMLElement;
            target.style.color = navItemUIData.value.color || '';
        }

        // 对配置中的导航做权限上的筛选
        const RE_NAVQUICK_LIST = computed(() => {
            return NAVQUICK_LIST.filter((item, index) => {
                if (index === 0 && isHome) {
                    return false;
                }
                if (index === 2) {
                    return abTestModel.hasNewReco();
                }
                return configModel.hasPermission(item.role);
            });
        });
        // 对配置中的导航做权限上的筛选
        const RE_NAVQUICK_MEDIUM_LIST = computed(() => {
            return NAVQUICK_MEDIUM_LIST.reduce((a, b, index) => {
                if (index === 0 && isHome) {
                    return a;
                }
                if (b.children) {
                    const children = b.children.filter(item => {
                        return configModel.hasPermission(item.role);
                    });
                    b = {
                        ...b,
                        children,
                    };
                    a.push(b);
                } else if (configModel.hasPermission(b.role)) {
                    if (index === 2 && abTestModel.hasNewReco()) {
                        a.push(b);
                    } else if (index !== 2) {
                        a.push(b);
                    }
                }
                return a;
            }, [] as typeof NAVQUICK_MEDIUM_LIST);
        });

        return {
            NAVQUICK_LIST: RE_NAVQUICK_LIST,
            NAVQUICK_MEDIUM_LIST: RE_NAVQUICK_MEDIUM_LIST,
            navItemUIData,
            hoverUIData,
            subListBackground,
            subHoverUI,
            subDefaultUI,
            subListArrow,
            log,
            isLogin,
            login,
            handleLink,
            isNewTag,
            isHigh,
            handleMoveEnter,
            handleMoveLeave,
        };
    },
});
